import * as action_types from './action_types';

export const configure = (data) => ({
  type: action_types.CONFIGURE,
  data: {
    w1Size: data.w1Size,
    w2Size: data.w2Size,
  },
});
